import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Textbox } from "@/App/components";
import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Subheading } from "capitalrx-components-2.0/lib/typography";

import { emailValidator, phoneNumberValidatorDashFormat } from "@/App/utils/validation";

interface DirectMemberReimbursementContactInformationFieldsProps {
  readonly smallColumns: number;
  readonly mediumColumns: number;
  readonly emailAddressFieldName: string;
  readonly phoneNumberFieldName: string;
}

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementContactInformationFields";

export const DirectMemberReimbursementContactInformationFields: FC<DirectMemberReimbursementContactInformationFieldsProps> = ({
  smallColumns,
  mediumColumns,
  emailAddressFieldName,
  phoneNumberFieldName,
}) => {
  const { t: translate } = useTranslation();

  return (
    <Stack spacing="medium">
      <Subheading>{translate(`${TRANSLATION_PATH}.contactInformation`)}</Subheading>
      <Body>{translate(`${TRANSLATION_PATH}.weMayContactYou`)}</Body>
      <Grid>
        <Grid.Span columns={mediumColumns}>
          <Textbox.Field
            name={emailAddressFieldName}
            label={translate(`${TRANSLATION_PATH}.emailAddress`)}
            instructions="email@address.com"
            validator={(value) => emailValidator(value, translate)}
            required
          />
        </Grid.Span>
        <Grid.Break />
        <Grid.Span columns={smallColumns}>
          <Textbox.Field
            name={phoneNumberFieldName}
            label={translate(`${TRANSLATION_PATH}.phoneNumber`)}
            instructions="123-456-7890"
            validator={(value) => phoneNumberValidatorDashFormat(value, translate)}
            required
          />
        </Grid.Span>
      </Grid>
    </Stack>
  );
};
